<template>
    <div class="aba-logs-integracao-sync">
        <loader v-if="isLoading" />
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="column" :class="[permissao.update ? 'is-8' : 'is-full']">
                        <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-logs-integracao" />
                    </div>
                    <div class="column is-4" v-if="permissao.update">
                        <button class="save-btn botao-acao" type="button" :disabled="isEmpty"
                            @click="promptConfirmacaoLiberacao()">
                            {{ $t("liberacao-pedido") }}
                        </button>
                    </div>
                </div>
                <div class="registry-wrapper">
                    <empty-table-message v-if="isEmpty" />
                    <b-table v-else :data="logIntegracaoSync" class="data-table" @sort="sortTable" backend-sorting>
                        <b-table-column v-for="(f, i) in fields" :key="i" :field="f.key" :label="$t(f.key)"
                            :width="f.width" :sortable="f.sortable" :custom-sort="f.sortFn" v-slot="props">
                            <div v-if="f.key == 'codigo'">
                                {{ props.row[f.key] }}
                            </div>
                            <div v-else-if="f.key == 'data-hora'">
                                {{
                                    props.row[f.key]
                                    ? $moment(
                                        props.row[f.key]
                                    ).format("L LT")
                                    : "—"
                                }}
                            </div>
                            <div v-else-if="f.key == 'mensagem'">
                                <span v-if="props.row[f.key].length < cutIn">{{ props.row[f.key] }}</span>
                                <b-collapse :open="false" position="is-bottom" aria-id="mensagem"
                                    v-else-if="props.row[f.key].length >= cutIn">
                                    <template #trigger="showText">
                                        <span v-if="!showText.open"><small>{{ verifyText(props.row[f.key]) }}</small></span>
                                        <a aria-controls="mensagem">
                                            <small>{{ !showText.open ? $t("mostrar") : $t("esconder") }}</small>
                                        </a>
                                    </template>
                                    <p class="force-break"><small>{{ props.row[f.key] }}</small></p>
                                </b-collapse>
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer 
                        class="mb-0" 
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows" 
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted" 
                        @change="updatePagination" 
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>

/*
    @87982 - visualização de logs de erros - integração de pedidos via mobile sync
*/
export default {
    props: {
        permissao: {
            type: Object,
            default: () => { }
        },
        pedido: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            logIntegracaoSync: [],
            fields: [
                { key: "codigo", sortable: true, sortFn: null },
                { key: "data-hora", width: 180, sortable: true, sortFn: null },
                { key: "mensagem", sortable: true, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: "",
            column: "mensagem",
            order: "asc",
            cutIn: 40,
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.carregarDados();

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-cli-logintegracao-sync" + numberId;
        },
        verifyText(str) {
            if (str.length > this.cutIn) str = str.substring(0, this.cutIn) + '...';
            return str;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.$axios.get(`/ven/synclogimportacao/logs.json`, {
                    params: {
                        page: currentPage - 1,
                        limit: this.pagination.perPage,
                        order: this.order,
                        column: this.column,
                        idregistro: this.pedido.idpedidosovisInt || this.pedido.idpedido,
                        entidade: "PEDIDO",
                        params: this.queryFilter
                    }
                })
                .then((response) => this.mapItems(response.data))
                .then((value) => {
                    this.logIntegracaoSync = value;
                    this.isEmpty = this.logIntegracaoSync.length <= 0;
                })
                .catch(() => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    "codigo": m.id,
                    "data-hora": m.dataHora,
                    "mensagem": m.mensagem,
                };
            });
        },
        promptConfirmacaoLiberacao() {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-liberacao"),
                onConfirm: (_) => {
                    this.liberarPedido();
                },
            });
        },
        /**
         *  @87982 - reseta o DATAHORAALT do pedido para que o servidor tente enviar novamente. 
         *  Na exporta_pedidos, esse processo é usando em alguns cliente que usam a API - para só 
         *  deixar enviar se o campo datahoraalt esta null, para evitar a perca de sequencial no erp 
         *  a cada tentativa. No processo normal, após o 1° envio ao erp é gravado no campo datahoraalt
        */
        liberarPedido() {
            this.isLoading = true;

            let idPedido = this.pedido.idpedidosovisInt || this.pedido.idpedido;

            this.$axios.get(`/liberacao/${idPedido}/pedido`)
                .then((value) => {
                    if (value.data.message == null) {
                        this.$root.showMessage("success", "msg-liberacao", true);
                        this.carregarDados();
                    } else {
                        if (this.$t(value.data.message)) {
                            this.$root.showMessage("alert", value.data.message, true);
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            );
                        }
                    }
                })
                .catch(() => {
                    this.$root.showMessage(
                        "error",
                        "msg-problema-realizar-acao",
                        true
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-logs-integracao-sync {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
}

.force-break {
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
}
</style>